export const classes = {
  wrapper: 'size-12 rounded-lg shadow-card place-center shrink-0',
  icon: 'fill-white size-10',
};
